module.exports = __webpack_public_path__ + "static/media/bulb.2af1794f.svg";